import {Injectable} from '@angular/core';
import * as UIModels from '@ui-app/models';
import {CountryEnum} from '@shared-models/common.models';
import {UserRoleEnum} from '@shared-models/common.enums';

@Injectable({
    providedIn: 'root'
})
export class UserRuleReader {
    isUSUser = false;
    isUSIUser = false;
    canVisitorsRequest = false;
    canBadgeRequest = false;

    user: UIModels.CM.IUserData | null;

    constructor() {
    }

    // Add US Role
    modifyUserRole(user: UIModels.CM.IUserData): UIModels.CM.IUserData {

        this.isUSUser = user.country === CountryEnum.US;
        this.isUSIUser = user.country === CountryEnum.USI;

        if (user.userRoleId === UserRoleEnum.Csba && this.isUSUser) {
            user.userRoleId = UserRoleEnum.CsbaUS;
        }

        if (user.userRoleId === UserRoleEnum.Csba && this.isUSIUser) {
            user.userRoleId = UserRoleEnum.CsbaUSI;
        }

        if (user.userRoleId === UserRoleEnum.Security && this.isUSUser) {
            user.userRoleId = UserRoleEnum.SecurityUS;
        }

        if (user.userRoleId === UserRoleEnum.Security && this.isUSIUser) {
            user.userRoleId = UserRoleEnum.SecurityUSI;
        }

        if (user.userRoleId === UserRoleEnum.Facilitator && this.isUSIUser) {
            user.userRoleId = UserRoleEnum.FacilitatorUSI;
        }

        if (user.userRoleId === UserRoleEnum.SeniorManager && this.isUSIUser) {
            user.userRoleId = UserRoleEnum.SeniorManagerUSI;
        }

        if (user.userRoleId === UserRoleEnum.FrontDesk && this.isUSIUser) {
            user.userRoleId = UserRoleEnum.FrontDeskUSI;
        }

        if (user.userRoleId === UserRoleEnum.Employee && this.isUSIUser) {
            user.userRoleId = UserRoleEnum.EmployeeUSI;
        }


        this.user = user;
        this.user.isUSI = this.isUSIUser
        return user;
    }

    checkByRole(rule: IUserRule): boolean {
        if (rule.exclude) {
            return this.user ? !rule.roles.includes(this.user.userRoleId) : false;
        } else {
            return this.user ? rule.roles.includes(this.user.userRoleId) : false;
        }
    }

    checkByCountry(rule: IUserRule): boolean {
        if (rule.exclude) {
            return this.user ? !rule.countries.includes(this.user.country) : false;
        } else {
            return this.user ? rule.countries.includes(this.user.country) : false;
        }
    }


}

export interface IUserRule {
    roles?: number[];
    exclude?: boolean;
    countries?: string[];
}

export interface IUserRules {
    [key: string]: IUserRule;
}
